import { computed } from 'vue'
import colors from '@/core/userColors.json'

export default (name) => {
  const colorsLength = colors.length - 1

  const userColor = computed(() => {
    const color = colors.find(i => i.name === name) || colors[Math.floor(Math.random() * colorsLength)]

    return `background: linear-gradient(to bottom, ${color.colors.join(', ')})`
  })

  function getColor (name) {
    const color = colors.find(i => i.name === name) || colors[Math.floor(Math.random() * colorsLength)]

    return `background: linear-gradient(to bottom, ${color.colors.join(', ')})`
  }

  return {
    userColor,
    getColor
  }
}
